import styled from '@emotion/styled';
import { useTheme } from '@mui/material/styles';
import ReactBarcode from 'react-barcode';
import { useState } from 'react';

export default function Barcode({ value = 'Mp771LK7', color, expandable = false, onDone }) {
  const theme = useTheme();
  const col = color || theme.palette.text.primary;
  const [hasError, setHasError] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  function handleClick() {
    if (expandable) {
      setIsOpen(true);
    }
  }

  if (hasError || !value) {
    return (
      <Wrap>
        <ErrorMessage>Code-barre invalide ou non scannable</ErrorMessage>
        <Value $color={theme.palette.text.disabled}>{value || 'N/A'}</Value>
      </Wrap>
    );
  }

  return (
    <>
      <Wrap
        onClick={handleClick}
        $expandable={expandable}
      >
        <BarcodeWrapper>
          <ReactBarcode
            value={value}
            format="CODE128"
            width={2.4}
            height={70}
            displayValue={false}
            background="transparent"
            lineColor={col}
            margin={0}
            onError={() => setHasError(true)}
          />
        </BarcodeWrapper>
        <Value $color={col}>{value}</Value>
        {expandable && <ExpandHint>🔍 Appuyer pour agrandir</ExpandHint>}
      </Wrap>

      {isOpen && (
        <Overlay onClick={() => setIsOpen(false)}>
          <CloseBtn
            onClick={e => { e.stopPropagation(); setIsOpen(false); }}
            aria-label="Fermer"
          >
            ✕
          </CloseBtn>
          <RotatedContent onClick={e => e.stopPropagation()}>
            <ReactBarcode
              value={value}
              format="CODE128"
              width={3}
              height={120}
              displayValue={false}
              background="#FFFFFF"
              lineColor="#000000"
              margin={8}
            />
            <FullscreenValue>{value}</FullscreenValue>
          </RotatedContent>
          {onDone && (
<DoneBtn type="button" onClick={e => { e.stopPropagation(); onDone(); }}>
              J&apos;ai rendu mon emballage
            </DoneBtn>
          )}
        </Overlay>
      )}
    </>
  );
}

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  width: 100%;
  cursor: ${p => p.$expandable ? 'pointer' : 'default'};
`;

const BarcodeWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;

  svg {
    width: 100%;
    max-width: 100%;
    height: auto;
  }
`;

const ErrorMessage = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: ${p => p.theme.palette.error.main};
  text-align: center;
  padding: 16px 0;
`;

const Value = styled.div`
  font-size: 13px;
  font-family: ${p => p.theme.typography.monorama.fontFamily};
  font-weight: 600;
  letter-spacing: 4px;
  color: ${p => p.$color || p.theme.palette.text.primary};
`;

const ExpandHint = styled.div`
  font-size: 11px;
  color: ${p => p.theme.palette.text.disabled};
  font-weight: 500;
  letter-spacing: 0.3px;
  margin-top: -4px;
`;

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 9999;
  background: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const CloseBtn = styled.button`
  position: fixed;
  top: 16px;
  right: 16px;
  z-index: 10000;
  background: rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 50%;
  width: 36px;
  height: 36px;
  font-size: 16px;
  color: #000000;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
`;

const RotatedContent = styled.div`
  width: 100vh;
  height: 100vw;
  transform: rotate(90deg);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 24px;
  box-sizing: border-box;

  svg {
    width: 100%;
    height: auto;
  }
`;

const FullscreenValue = styled.div`
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 6px;
  color: #000000;
`;

const DoneBtn = styled.button`
  position: absolute;
  bottom: max(16px, env(safe-area-inset-bottom));
  left: 16px;
  right: 16px;
  padding: 15px 24px;
  border-radius: 12px;
  background: ${p => p.theme.palette.primary.main};
  border: none;
  color: #FFFFFF;
  font-size: 15px;
  font-weight: 700;
  font-family: ${p => p.theme.typography.fontFamily};
  cursor: pointer;
  z-index: 10001;
  &:active {
    opacity: 0.85;
  }
`;
